import React from 'react';
import styled from '@emotion/styled';
import HudsonLogo from '../images/hudson-logo.png';
import { RiFileWarningFill } from 'react-icons/ri';

export const TopBarStyles = styled.div`
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #c0bcb4;
  justify-content: space-between;
  padding: 0 16px;
  position: relative;
  height: 70px;
  @media (min-width: 768px) {
    padding: 0 40px;
  }
  @media (min-width: 1024px) {
    padding: 0 70px;
  }
  @media (min-width: 1700px) {
    padding: 0 230px;
  }
`;

const PageWrap = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  > div:first-of-type {
    flex: 0 0 auto;
  }
  .contentWrap {
    padding: 20px;
    display: flex;
    flex: 1;
    justify-content: center;
  }
  .innerContent {
    flex-direction: column;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    line-height: 1.7;
  }
  .pointer {
    cursor: pointer;
  }
  .sorryText {
    justify-content: center;
    display: flex;
    margin-top: 30px;
  }
`;

const GlobalError = () => {
  return (
    <PageWrap>
      <TopBarStyles>
        <div className="pointer">
          <img src={HudsonLogo} style={{ width: 'auto', height: 48 }} alt="" />
        </div>
      </TopBarStyles>
      <div className="contentWrap">
        <div className="innerContent">
          <RiFileWarningFill size={170} />
          <div className="sorryText">Sorry, we are experiencing technical issues right now.</div>
          <div>
            Please reach out to us by email
            <a
              href="mailto:orders@hudsonsearch.com?subject=Internal server error&cc=sdavidowitz@hudsonsearch.com"
              style={{ marginLeft: 4, marginRight: 4 }}
            >
              orders@hudsonsearch.com
            </a>
            or by phone at 866-260-9308.
          </div>
        </div>
      </div>
    </PageWrap>
  );
};

export default GlobalError;
